import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../hooks/redux';
import { getOAuthConnectUrl } from '../../store/slices/googleReviewSlice';

const GoogleGIcon: React.FC = () => (
  <svg width="16" height="16" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.875 2.684-6.615Z" fill="#4285F4" />
    <path d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18Z" fill="#34A853" />
    <path d="M3.964 10.71A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.042l3.007-2.332Z" fill="#FBBC05" />
    <path d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58Z" fill="#EA4335" />
  </svg>
);

const ReviewListHeader: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const accountEmail = useAppSelector((state) => state.googleReview.accountEmail);
  const [isConnecting, setIsConnecting] = useState(false);

  const handleConnect = async () => {
    setIsConnecting(true);
    try {
      const result = await dispatch(getOAuthConnectUrl()).unwrap() as { url: string };
      if (result.url && result.url !== '#mock-oauth') {
        window.location.href = result.url;
      }
    } finally {
      setIsConnecting(false);
    }
  };

  return (
    <div className="review-list-header">
      <div className="review-list-header__left">
        <h1 className="review-list-header__title">{t('google_review_manager_title')}</h1>
        {accountEmail && (
          <span className="review-list-header__account-email">{accountEmail}</span>
        )}
        <Link
          to="/features/google-review-manager/settings"
          className="review-list-header__settings-btn"
        >
          ⚙ {t('google_review_settings_button')}
        </Link>
      </div>

      <button
        type="button"
        className="review-list-header__connect-btn"
        onClick={handleConnect}
        disabled={isConnecting}
      >
        <GoogleGIcon />
        {isConnecting ? t('loading_text') : t('google_review_change_account_button')}
      </button>
    </div>
  );
};

export default ReviewListHeader;
